import { ReactElement, ComponentProps } from 'react';

import cn from 'classnames';

import styles from './styles.module.scss';

import GearImg from ':images/errors/gear.webp';
import GearImg2x from ':images/errors/gear@2x.webp';
import GearImg3x from ':images/errors/gear@3x.webp';

type ErrorImageProps = {
  className?: string;
} & ComponentProps<'img'>;

export function ErrorImage({
  className,
  alt = 'ошибка',
  ...rest
}: ErrorImageProps): ReactElement {
  return (
    <img
      src={GearImg}
      alt={alt}
      srcSet={`${GearImg2x} 2x, ${GearImg3x} 3x`}
      className={cn(styles.errorImg, className)}
      {...rest}
    />
  );
}
